module.exports = __webpack_public_path__ + "static/media/ilha_5.c181bbf9.jpg";